import { Link } from "react-router-dom";
import { CONTACT, PublicPage, Section, UPDATED } from "../../components/PublicLayout";

export default function Terms() {
  return (
    <PublicPage testId="public-terms-page" eyebrow="Terms" title="SMS Terms & Conditions and App Terms" updated={UPDATED}>
      <p className="text-sm leading-relaxed text-zinc-300" data-testid="terms-operator-intro">These Terms are provided by CampbellsLife LLC, doing business as GamedayTime (&ldquo;GamedayTime&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;). GamedayTime is a DBA of CampbellsLife LLC.</p>
      <Section title="SMS program" id="sms">
        <p><strong>GamedayTime Crew Notifications</strong>: work-related texts from GamedayTime for invited GamedayTime employees and crew, including verification codes, clock-in/clock-out links and confirmations, break confirmations, shift status replies and account notices.</p>
        <p><strong>Opt-in:</strong> you opt in during invitation-only registration by checking an unchecked consent box and verifying your phone with a one-time code. See <Link to="/sms" className="text-signal">how the SMS program works</Link>.</p>
        <p>Message frequency varies. Message and data rates may apply.</p>
        <p>Reply <strong>HELP</strong> for help. Reply <strong>STOP</strong> (or END, CANCEL, UNSUBSCRIBE, QUIT) to opt out. Reply <strong>START</strong> to opt back in.</p>
        <p>Carriers are not liable for delayed or undelivered messages.</p>
        <p>Support: <a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a>. Privacy: <Link to="/privacy" className="text-signal" data-testid="terms-privacy-link">Privacy Policy</Link>.</p>
      </Section>
      <Section title="Who may use GamedayTime">
        <p>GamedayTime is for authorized GamedayTime personnel only.</p>
      </Section>
      <Section title="Account security">
        <p>Keep your login codes, password and authenticator private. Tell us right away at {CONTACT} if you think your account was used by someone else.</p>
      </Section>
      <Section title="Accurate time reports">
        <p>Report your time honestly. If a punch is wrong or missing, use the correction request in the app; an administrator reviews every correction and the original record is kept.</p>
      </Section>
      <Section title="Payments">
        <p>No payments are made through the app. Your employer pays wages outside the app; GamedayTime only keeps records.</p>
      </Section>
      <Section title="Acceptable use">
        <p>Don't misuse the app, share accounts, submit false location or time data, or try to access other people's information.</p>
      </Section>
      <Section title="Changes">
        <p>We may update these terms. The "Last updated" date above shows the latest version.</p>
      </Section>
      <Section title="Contact">
        <p><a className="text-signal" href={`mailto:${CONTACT}`}>{CONTACT}</a></p>
      </Section>
    </PublicPage>
  );
}
